import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { siteNav } from "@/mocks/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setKeyword("");
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-sparkling-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl text-foreground-950">妖精漫画</span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {siteNav.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/"}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <form onSubmit={handleSearch} className="relative">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画 / 资讯"
              className="h-9 w-52 rounded-full border border-background-300 bg-background-50 pl-9 pr-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
            />
          </form>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-100 md:hidden cursor-pointer"
          aria-label="打开菜单"
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <form onSubmit={handleSearch} className="relative mb-3">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画 / 资讯"
              className="h-10 w-full rounded-full border border-background-300 bg-background-50 pl-9 pr-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
            />
          </form>
          <nav className="flex flex-col gap-1">
            {siteNav.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}